<div class="dropdown-field" [class.disabled]="!editable()">
    <div class="input-group">
        <button
            class="form-control flex-grow-1 dropdown-trigger text-start"
            type="button"
            [disabled]="!editable()"
            [class.is-valid]="isValid()"
            [class.is-invalid]="isInvalid()"
            [class.placeholder-shown]="!hasSelection()"
            [attr.aria-label]="ariaLabel()"
            [attr.aria-invalid]="isInvalid()"
            [attr.aria-expanded]="isOpen()"
            aria-haspopup="listbox"
            (click)="toggleMenu()"
            (keydown.escape)="closeMenu()"
        >
            {{ triggerLabel() }}
        </button>
        @if (scannable()) {
            <button
                class="btn btn-secondary scan-button"
                type="button"
                [disabled]="!editable()"
                [attr.aria-label]="'BARCODE_SCANNER_SET_TITLE' | translate"
                (click)="scan()"
            >
                <fa-icon [icon]="faBarcode" size="2x"></fa-icon>
            </button>
        }
        <!--
            Visually part of the control, so it has to open the menu too. Kept out of the
            tab order and hidden from assistive tech because the trigger beside it already
            does the same job for keyboard and screen-reader users.
        -->
        <button
            class="input-group-text caret-button"
            type="button"
            tabindex="-1"
            aria-hidden="true"
            [disabled]="!editable()"
            (click)="toggleMenu()"
        >
            <fa-icon [icon]="faCaretDown"></fa-icon>
        </button>
    </div>

    @if (isOpen()) {
        <ul class="dropdown-menu show" role="listbox" [attr.aria-multiselectable]="isMultiSelect()">
            @if (showSearch()) {
                <li class="px-2 pb-2">
                    <input
                        class="form-control dropdown-search"
                        type="search"
                        [value]="searchTerm()"
                        [attr.aria-label]="ariaLabel() + ' search'"
                        (click)="$event.stopPropagation()"
                        (input)="onSearch($event)"
                        (keydown.escape)="closeMenu()"
                    />
                </li>
            }
            @for (option of visibleOptions(); track option.value) {
                <li>
                    <button
                        class="dropdown-item"
                        type="button"
                        role="option"
                        [disabled]="!isSelectable(option)"
                        [class.highlight-selection]="isSelected(option)"
                        [attr.aria-selected]="isSelected(option)"
                        (click)="select(option)"
                    >
                        {{ option.label }}
                    </button>
                </li>
            }
            @if (visibleOptions().length === 0) {
                <li class="dropdown-item-text no-matches">&mdash;</li>
            }
        </ul>
    }
</div>

@if (isMultiSelect() && selectedOptions().length > 0) {
    <ul class="tags">
        @for (option of selectedOptions(); track option.value) {
            <li>
                {{ option.label }}
                <button
                    class="tag-remove"
                    type="button"
                    [disabled]="!editable()"
                    [attr.aria-label]="'Remove ' + option.label"
                    (click)="remove(option)"
                >
                    <fa-icon class="mx-1" [icon]="faTimes"></fa-icon>
                </button>
            </li>
        }
    </ul>
}

@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
